import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { v2Host } from '@/config/host';
import { getToken } from '@/utils/auth';
import { getApiPath } from '@/common/api-proxy.js';
import _ from 'lodash';
import LanguageSelector from '@/components/LanguageSelector/index.vue';
import { addFont, updateFont } from '@/api/common/font'; // updateFont

var _default = {
  name: '',
  languages: '',
  tag_ids: [],
  font_file: '',
  svg_file: '',
  order: ''
};

export default {
  name: 'add-update-dialog.vue',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String, // add,update
      default: 'add'
    },
    fontList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentFont: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      saving: false,
      loading: false,
      model: _extends({}, _default),
      coverFile: [],
      fontFile: [],
      formConfig: {
        inline: false,
        labelPosition: 'right',
        labelWidth: '100px'
      }
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },
    dialogAttrs: function dialogAttrs() {
      return {
        title: this.type === 'add' ? '添加字体' : '更新字体'
      };
    },
    submitButtonAttrs: function submitButtonAttrs() {
      return {
        type: 'primary',
        size: 'mini',
        loading: this.saving
      };
    },
    cancelButtonAttrs: function cancelButtonAttrs() {
      return {
        size: 'mini',
        loading: this.saving
      };
    },
    uploadConfig: function uploadConfig() {
      return {
        action: '' + v2Host + getApiPath('/upload/file'),
        headers: {
          'Auth-Token': getToken()
        },
        drag: true
      };
    },
    innerFontList: function innerFontList() {
      return this.fontList.map(function (item) {
        return {
          value: item.id,
          label: item.name
        };
      });
    },
    schema: function schema() {
      var _this = this;

      return {
        type: 'object',
        properties: {
          name: {
            component: 'input',
            title: '名称：',
            rules: [{ required: true, message: '名称不能为空', trigger: ['change'] }],
            prop: 'name',
            field: {
              style: {
                width: '250px'
              },
              maxlength: 64,
              'show-word-limit': true
            }
          },
          languages: {
            prop: 'languages',
            component: LanguageSelector,
            title: '语言：',
            field: {
              multiple: true,
              clearable: true
            }
          },
          tag_ids: {
            prop: 'tag_ids',
            component: 'select',
            title: '标签：',
            field: {
              multiple: true,
              clearable: true,
              options: this.innerFontList || []
            }
          },
          order: {
            component: 'input',
            title: '优先级：',
            prop: 'order',
            field: {
              type: 'number',
              style: {
                width: '250px'
              }
            }
          },
          svg_file: {
            component: 'upload',
            title: '封面图：',
            rules: [{ required: true, message: '请上传svg文件', trigger: ['change'] }],
            prop: 'svg_file',
            field: _extends({}, this.uploadConfig, {
              accept: '.svg',
              onRemove: function onRemove(file, fileList) {
                _this.handleRemove({
                  prop: 'svg_file',
                  file: file,
                  fileList: fileList
                });
              },
              fileList: this.coverFile,
              onChange: this.onChange,
              onSuccess: function onSuccess(res, file, fileList) {
                _this.onSuccess({
                  prop: 'svg_file',
                  res: res,
                  file: file,
                  fileList: fileList
                });
              },
              uploadText: '将文件拖到此处或点击,支持svg'
            })
          },
          font_file: {
            visible: this.type === 'add',
            component: 'upload',
            title: '字体文件：',
            rules: [{
              required: true,
              message: '请上传字体文件',
              trigger: ['change']
            }],
            prop: 'font_file',
            field: _extends({
              accept: '.ttf,.otf'
            }, this.uploadConfig, {
              fileList: this.fontFile,
              onRemove: function onRemove(file, fileList) {
                _this.handleRemove({
                  prop: 'font_file',
                  file: file,
                  fileList: fileList
                });
              },
              onChange: this.onChange,
              onSuccess: function onSuccess(res, file, fileList) {
                _this.onSuccess({
                  prop: 'font_file',
                  res: res,
                  file: file,
                  fileList: fileList
                });
              },
              uploadText: '将文件拖到此处或点击，支持ttf、otf格式'
            })
          }
        }
      };
    }
  },
  methods: {
    initData: function initData() {
      if (!_.isEmpty(this.currentFont)) {
        var _currentFont = this.currentFont,
            name = _currentFont.name,
            languages = _currentFont.languages,
            tag_ids = _currentFont.tag_ids,
            font_url = _currentFont.font_url,
            svg_url = _currentFont.svg_url,
            order = _currentFont.order;

        if (svg_url) {
          var fileName = svg_url.split('/');
          this.coverFile = [{
            name: fileName[fileName.length - 1],
            url: svg_url
          }];
        }
        if (font_url) {
          var _fileName = font_url.split('/');
          this.fontFile = [{
            name: _fileName[_fileName.length - 1],
            url: font_url
          }];
        }
        this.model = _extends({}, this.model, {
          name: name,
          languages: languages ? languages.split(',') : [],
          tag_ids: _.isArray(tag_ids) ? tag_ids : [],
          font_file: font_url,
          svg_file: svg_url,
          order: order
        });
      } else {
        this.model = _extends({}, _default);
      }
    },
    handleRemove: function handleRemove(_ref) {
      var prop = _ref.prop,
          file = _ref.file,
          fileList = _ref.fileList;

      this.model[prop] = '';
    },
    onChange: function onChange(file, fileList) {
      this.$refs.form.validate();
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    onSuccess: function onSuccess(_ref2) {
      var _this2 = this;

      var prop = _ref2.prop,
          res = _ref2.res,
          file = _ref2.file,
          fileList = _ref2.fileList;

      var update = function update() {
        _this2.model[prop] = _.get(file, 'response.data.file_path') || '';
      };

      if (res.code === 0) {
        update();
      } else {
        this.onError(res);
        fileList.splice(0, 1);
      }
    },
    close: function close() {
      this.dialogVisible = false;
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, _model, name, languages, tag_ids, font_file, svg_file, order, postData, _res;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.saving = true;

                if (!(_this3.type === 'add')) {
                  _context.next = 9;
                  break;
                }

                _context.next = 5;
                return addFont(_extends({}, _this3.model));

              case 5:
                res = _context.sent;

                if (_.get(res, 'data.code') === 0) {
                  _this3.close();
                  _this3.$emit('reload');
                }
                _context.next = 17;
                break;

              case 9:
                // 更新字体
                _model = _this3.model, name = _model.name, languages = _model.languages, tag_ids = _model.tag_ids, font_file = _model.font_file, svg_file = _model.svg_file, order = _model.order;
                postData = {
                  id: _this3.currentFont.id,
                  name: name,
                  languages: languages,
                  tag_ids: tag_ids,
                  order: order
                  // 修改字体
                };
                if (font_file.indexOf('portal://') !== -1) {
                  postData.font_file = font_file;
                }
                // 修改封面
                if (svg_file.indexOf('portal://') !== -1) {
                  postData.svg_file = svg_file;
                }
                _context.next = 15;
                return updateFont(_extends({
                  id: _this3.currentFont.id
                }, postData));

              case 15:
                _res = _context.sent;

                if (_.get(_res, 'data.code') === 0) {
                  _this3.close();
                  _this3.$emit('reload');
                }

              case 17:
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 22:
                _this3.saving = false;

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 19]]);
      }))();
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val === false) {
        this.saving = false;
        this.loading = false;
        this.coverFile = [];
        this.fontFile = [];
      } else {
        this.$refs.form && this.$refs.form.resetFields();
        this.initData();
      }
    }
  }
};